import React, { Component } from 'react';
import hoistStatics from 'hoist-non-react-statics';

/**
 * Display error - stub.
 * @param {*} message
 */
function show(message) {
  console.warn(message);
}

/**
 * Display graphql errors stub.
 * @param {*} errors
 * @param {*} options
 */
function showAnyGraphQlErrors(errors, options) {
  show(errors, options);
}

export const NotificationContext = React.createContext({
  show,
  showAnyGraphQlErrors,
});

const getDisplayName = name => `withNotification(${name})`;

/**
 * Wraps any compponent and provides the `growl` prop.
 *
 * @param {*} WrappedComponent
 */
export const withGrowl = (WrappedComponent) => {
  const Context = NotificationContext;
  const displayName = getDisplayName(WrappedComponent.displayName || WrappedComponent.name || 'Component');

  class WithAccountComponent extends Component {
    renderWrappedComponent = value => <WrappedComponent {...this.props} growl={value} />;

    render() {
      return <Context.Consumer>{this.renderWrappedComponent}</Context.Consumer>;
    }
  }

  WithAccountComponent.WrappedComponent = WrappedComponent;
  WithAccountComponent.displayName = displayName;
  return hoistStatics(WithAccountComponent, WrappedComponent);
};
